import { InjectionToken } from '@angular/core';

/**
 * Configuration for start of week
 */
export const START_OF_WEEK = new InjectionToken<0 | 1 | 2 | 3 | 4 | 5 | 6>('date.start_of_week');
